var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSuitcaseSimple = function SvgIconSuitcaseSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.982 2.732A2.5 2.5 0 0 1 9.75 2h4.5a2.5 2.5 0 0 1 2.5 2.5v.875h3.5c.966 0 1.75.784 1.75 1.75v12a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 19.125v-12c0-.966.784-1.75 1.75-1.75h3.5V4.5a2.5 2.5 0 0 1 .732-1.768M4 16v2.875h16V16zm16-2H4V7.375h16zm-5.25-9.5v.875h-5.5V4.5a.5.5 0 0 1 .5-.5h4.5a.5.5 0 0 1 .5.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconSuitcaseSimple;